module.exports = __webpack_public_path__ + "f7e60a3aa25d833de9a4a2f7213bce4e.png";